import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import AuthTemplate from "../../templates/Auth";
import { Link, useParams } from "react-router-dom";

import Input from "../../components/Input";
import Button from "../../components/Button";

import { renderError } from "../../helpers/errors";
import api from "../../services/api";
import PasswordChecklist from "../../components/PasswordChecklist";

export const PasswordTokenValidate = () => {
    const { recovery_token } = useParams();

    const [isValid, setIsValid] = useState(null);
    const [loading, setLoading] = useState(true);

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [recaptchaToken, setRecaptchaToken] = useState('');
    const [isValidPassword, setIsValidPassword] = useState(false);

    const recaptchaKey = process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY;

    useEffect(() => {
        api.post(`/validate-recovery-token`, { 
            recovery_token, 
        }).then(res => {
            setIsValid(res.data.valid);
        }).catch(error => {
            setIsValid(false);
        }).finally(() => setLoading(false));
    }, [recovery_token]);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaKey}`;
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
            window.grecaptcha.ready(() => {
                window.grecaptcha
                    .execute(recaptchaKey, { action: 'login' })
                    .then(token => {
                        setRecaptchaToken(token);
                        setLoading(false);
                    })
                    .catch(error => {
                        console.error('Erro ao gerar token do reCAPTCHA:', error);
                        toast.error('Erro ao carregar o reCAPTCHA');
                        setLoading(false);
                    });
            });
        };

        return () => {
            document.body.removeChild(script);
        };
    }, [recaptchaKey]);

    const savePassword = () => {
        if (!recaptchaToken) {
            toast.error("Erro ao carregar o reCAPTCHA.");
            return;
        }

        setLoading(true);

        api.post(`/reset-password`, { 
            recovery_token,
            password, 
            password_confirmation: confirmPassword,
            recaptcha_token: recaptchaToken
        }).then(res => {
            window.location.href = "/login";
        }).catch(error => {
            renderError(error);

            window.grecaptcha.ready(() => {
                window.grecaptcha
                    .execute(recaptchaKey, { action: 'login' })
                    .then(token => setRecaptchaToken(token))
                    .catch(error => {
                        console.error('Erro ao gerar token do reCAPTCHA:', error);
                        toast.error('Erro ao carregar o reCAPTCHA');
                    });
            });
        }).finally(() => setLoading(false));
    };

    const handleCriteriaChange = (criteria) => {
        const allValid = Object.values(criteria).every(Boolean);
        setIsValidPassword(allValid);
    };

    return (
        <AuthTemplate>            
            <div className="box-pass-validate">
                {loading && <p>Verificando token...</p>}  

                {!loading && !isValid && (
                <div>
                    <h2 className="mb-15">Link inválido ou expirado</h2>
                    <p>Solicite novamente a recuperação de senha.</p>
                    <br />
                    <span>
                        Retorne ao login
                        <Link to="/login" className="mt-4 text-sm text-blue-600 left">
                            clicando aqui
                        </Link>
                    </span>
                </div>
            )}

            {!loading && isValid && (
                <div>
                    <h2 className="mb-40">Redefinir senha</h2>

                    <Input type={`password`} label={`Senha`} change={setPassword} value={password} action={savePassword} />
                    <Input type={`password`} label={`Confirme a senha`} change={setConfirmPassword} value={confirmPassword} action={savePassword} />
                    <PasswordChecklist password={password} confirmPassword={confirmPassword} onCriteriaChange={handleCriteriaChange}/>
                    <Button type={`primary`} text={`Atualizar senha`} full={true} disabled={!isValidPassword} svg={`arrow-right-white`} loading={loading} action={savePassword} />
                </div>
            )}           
            </div>
        </AuthTemplate>
    );
}

export default PasswordTokenValidate;